import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { SelectedAccountReportParameter } from '@ndt/report-output/shared/models/selected-account-report-parameter';
import {
   ParameterFormValueUnion,
   convertFromFormValueList,
} from '@ndt/reports/shared/report-parameter-list/models/report-parameter-form-value';
import {
   ReportParametersUnion,
   convertToForm,
} from '@ndt/reports/shared/report-parameter-list/models/report-parameter-union.model';
import { ReportParameterConfig } from '@ndt/reports/shared/report-parameter-list/report-parameter.config';
import {
   ReportParameterFormService,
   ReportParameterFormServiceBase,
} from '@ndt/reports/shared/report-parameter-list/services/report-parameter-form.service';
import { ReportParameters } from 'generated/graphql-types';
import { LcsDateTimeAdapter } from 'src/app/common-components/date-time-picker/configuration/date-time-adapter';
import { CallParkingReportParameters } from '../models/call-parking-report-parameters';

export class CallParkingParametersFormService
   extends ReportParameterFormServiceBase
   implements ReportParameterFormService<CallParkingReportParameters>
{
   config: ReportParameterConfig[];

   form: UntypedFormGroup;

   accountId: number | null = null;

   constructor(fb: UntypedFormBuilder, private dateAdapter: LcsDateTimeAdapter<Date>) {
      super(fb);

      const initialValue: ReportParametersUnion[] = [
         {
            parameterType: ReportParameters.SelectedAccount,
            sortOrder: 1,
            value: null,
            name: null,
         },
      ];

      this.config = [
         {
            label: 'Selected Account',
            type: 'selectedAccount',
         },
      ];

      this.form = convertToForm(initialValue, fb);
   }

   convertValue(values: ReportParametersUnion[]): CallParkingReportParameters | null {
      const selectedAccount = values.find((v) => {
         return v.parameterType === ReportParameters.SelectedAccount;
      }) as SelectedAccountReportParameter | undefined;

      const output: CallParkingReportParameters = {
         selectedAccount,
         tileLayoutConfiguration: this.getLayoutConfigurations(values),
      };

      return output;
   }

   getValue(): CallParkingReportParameters | null {
      const formValue = this.form.getRawValue();
      const values: ParameterFormValueUnion[] = this.convertCallParkingAccountValue(formValue.values);
      const convertedValues = convertFromFormValueList(values);
      return this.convertValue(convertedValues);
   }

   isListComplete(values: ReportParametersUnion[], _includeAskParameter = false): boolean {
      const selectedAccount = values.find((v) => {
         return v.parameterType === ReportParameters.SelectedAccount;
      });

      return !!selectedAccount;
   }

   orderValues(): void {
      const { values } = this.form.value;
      this.form.setValue({
         values: [...values].map((v) => {
            return {
               ...v,
            };
         }),
      });
   }

   patchSavedValues(values: ReportParametersUnion[]): void {
      super.patchSavedValues(values, false, false);
   }

   setValue(values: ParameterFormValueUnion[]): void {
      this.form.setValue(values);
   }

   private convertCallParkingAccountValue(values): ParameterFormValueUnion[] {
      return values.map((v) => {
         if (v.parameterType === ReportParameters.SelectedAccount) {
            if (v.value && v.value.accountId !== undefined) {
               this.accountId = v.value.accountId;
               return { ...v, value: v.value.accountId, name: v.value.name || 0 };
            } else {
               return { ...v, value: v.value || 0 };
            }
         }
         return v;
      });
   }
}
